import { isNil } from "ramda";
export function translate(value, translations) {
    if (Array.isArray(value)) {
        return value.map(value => translate(value, translations));
    }
    else if (typeof value === "object" && !isNil(value)) {
        return Object.fromEntries(Object.entries(value).map(([key, value]) => [key, translate(value, translations)]));
    }
    else if (typeof value === "string") {
        return translations.reduce((value, translation) => value.replace(new RegExp("\b" + translation.pattern + "\b", "i"), translation.replacement), value);
    }
    else {
        return value;
    }
}
